import { ActionTooltip } from "../../styledComponents/tasks";

const TaskActionTooltip = (props) => {
  return <ActionTooltip>{props.toolTipText}</ActionTooltip>;
};

export default TaskActionTooltip;
